import { useEffect, useCallback, useRef } from 'react';
import { useSyncStatus } from '@/hooks/useSyncStatus';
import { backgroundSync } from '@/lib/services/background-sync-service';
import { SyncIndicator } from './SyncIndicator';
import { useOfflineDetection } from '@/hooks/useOfflineDetection';
import { useAuth } from '@/contexts/AuthContext';

export const SyncStatusIndicator = () => {
  const { isOffline } = useOfflineDetection();
   const { inProgress, lastSyncTime } = useSyncStatus();
   const { user, loading: authLoading } = useAuth();
   const hasSyncedOnMount = useRef(false);
 
   // Memoized sync function that checks auth state
   const triggerSync = useCallback(async () => {
     // Don't sync if not authenticated
     if (!user || authLoading) {
       console.log('SyncStatusIndicator: Skipping sync - not authenticated');
       return;
     }
     
     try {
       await backgroundSync.syncNow();
     } catch (error) {
       console.error('SyncStatusIndicator: Sync error', error);
     }
   }, [user, authLoading]);
 
   // Attempt to sync once on mount when authenticated
  useEffect(() => {
     // Only sync once on mount, when authenticated and online
     if (!hasSyncedOnMount.current && user && !authLoading && !isOffline && !inProgress) {
       hasSyncedOnMount.current = true;
       
       // Delay to allow UI to render first
       const timeoutId = setTimeout(() => {
         triggerSync();
       }, 2000);
       
       return () => clearTimeout(timeoutId);
    }
   }, [user, authLoading, isOffline, inProgress, triggerSync]);
  
  return (
    <SyncIndicator
      isSyncing={inProgress}
      lastSyncTime={lastSyncTime}
      className="flex-shrink-0"
    />
  );
};
